import { useEffect, useState } from "react";

const navItems = [
  { label: "Processing", href: "#processing-options" },
  { label: "Services", href: "#services" },
  { label: "Local Info", href: "#service-area" },
  { label: "Travel Timing", href: "#travel-timing" },
  { label: "Destinations", href: "#destinations" },
  { label: "Facilities", href: "#acceptance-facilities" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "FAQ", href: "#faq" },
];

export default function PlantationStickyNav() {
  const [isSticky, setIsSticky] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsSticky(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <nav
      className={`sticky top-0 z-50 transition-all duration-300 ${
        isSticky
          ? "bg-white shadow-md border-b border-gray-100"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <a href="https://fastpassportcenter.com" className="flex items-center gap-2">
            <img
              src="https://staging.fastpassportcenter.com/wp-content/uploads/2026/02/Footer.svg"
              alt="Fast Passport Center"
              className={`h-7 w-auto transition-opacity duration-300 ${isSticky ? "opacity-100" : "opacity-0"}`}
            />
            <span className={`font-bold text-sm text-[#1A365D] transition-opacity duration-300 ${isSticky ? "opacity-100" : "opacity-0"}`}>
              Plantation, FL
            </span>
          </a>

          {/* Desktop nav */}
          <div className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <button
                key={item.href}
                onClick={() => handleClick(item.href)}
                className={`px-3 py-2 rounded-md text-xs font-semibold uppercase tracking-wider transition-all cursor-pointer whitespace-nowrap ${
                  isSticky
                    ? "text-[#1A365D] hover:bg-[#F7F8FA]"
                    : "text-white/80 hover:text-white hover:bg-white/10"
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>

          {/* CTA + Mobile toggle */}
          <div className="flex items-center gap-3">
            <a
              href="https://fastpassportcenter.com/checkout/"
              className={`hidden sm:inline-flex items-center gap-1.5 font-bold text-xs px-4 py-2 rounded-md transition-all whitespace-nowrap ${
                isSticky
                  ? "bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D]"
                  : "bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D]"
              }`}
            >
              Start Now <i className="ri-arrow-right-line"></i>
            </a>
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className={`lg:hidden w-9 h-9 flex items-center justify-center rounded-md transition-colors cursor-pointer ${
                isSticky ? "text-[#1A365D] hover:bg-[#F7F8FA]" : "text-white hover:bg-white/10"
              }`}
              aria-label="Toggle menu"
            >
              <i className={`${mobileOpen ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100 shadow-lg">
          <div className="max-w-7xl mx-auto px-4 py-4 space-y-1">
            {navItems.map((item) => (
              <button
                key={item.href}
                onClick={() => handleClick(item.href)}
                className="block w-full text-left px-4 py-3 text-sm font-semibold text-[#1A365D] hover:bg-[#F7F8FA] rounded-md transition-colors cursor-pointer"
              >
                {item.label}
              </button>
            ))}
            <a
              href="https://fastpassportcenter.com/checkout/"
              className="block w-full text-center mt-3 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-4 py-3 rounded-md transition-all whitespace-nowrap"
            >
              Start Your Passport
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}